<template>
        <div class="row top">
            <div class="row">
                <div class="col-md-2">
                    <back-button returnUrl="/Announcements/Index"></back-button>
                </div>
            </div>
            <div class="col-md-1" style>
                <DxLoadIndicator id="image-indicator" :height="40" :width="40" :visible="loadIndicatorVisible" />
            </div>
            <div class="row">
                <div class="col-md-12">
                    <h4><u>Λεπτομέρειες Ανακοίνωσης</u></h4>
                </div>
            </div>

            <Panel v-if="renderPanel" :announcement="this.announcement" />
            <IsSeenTable v-if="renderTable && hasAdminRights" :organizations="this.organizations" />
        </div>
</template>
<script>
import BackButton from "../../components/shared/backButton";
import DxLoadIndicator from "devextreme-vue/load-indicator";
import mainService from "../../services/mainService";
import Panel from "./Children/Panel.vue"
import IsSeenTable from "./Children/IsSeenTable.vue";
import notify from "devextreme/ui/notify";
export default {
    components: {
        BackButton,
        DxLoadIndicator,
        Panel,
        IsSeenTable
    },
    data() {
        return {
            announcement: {},
            organizations: [],
            loadIndicatorVisible: false,
            renderPanel: false,
            renderTable: false,
        }
    },
    async mounted() {
        await this.initialization();
    },
    computed: {
        hasAdminRights() {
            return this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin
        },
        organizationId() {
            return this.$store.getters.getSelectedOrganizationId;
        },
    },
    methods: {
        async initialization() {
            try {
                this.loadIndicatorVisible = true;

                if (this.hasAdminRights)
                {
                    const announcement = await mainService.get('/announcements/GetAnnouncementAdmin?id=' + this.$route.params.Id);
                    this.announcement = announcement.data;
                    this.renderPanel = true;

                    const organizations = await mainService.get(`/announcements/GetOrganizationAnnouncements?announcementsId=${this.$route.params.Id}`);
                    this.organizations = organizations.data;
                    this.renderTable = true;
                }
                else
                {
                    const announcement = await mainService.get(`/announcements/GetAnnouncementUser?id=${this.$route.params.Id}&organizationId=${this.organizationId}`);
                    this.announcement = announcement.data;
                    this.renderPanel = true;
                    await mainService.put(`/announcements/MarkAsSeen?announcementId=${this.$route.params.Id}&organizationId=${this.organizationId}`);
                }

                this.loadIndicatorVisible = false;
            } catch (error) {
                notify("Κάτι πήγε στραβά", "error", 10000);
                this.loadIndicatorVisible = false;
            }
        }
    }
}
</script>